export default "__VITE_ASSET__e9OfWt8k__"